export const orderStatus = [
    '처리중',
    '배송중',
    '주문반려',
    '처리완료'
]



// WEBPACK FOOTER //
// ./src/pages/Admin/OrderManager/constants/constants.js